import axios from "../api/AxiosInstance"; // Make sure this path is correct and AxiosInstance.js exports a valid axios instance
export const getProfileData = async (token) => {
  console.log("Debug log get profile data");
  // const header = { 'Authorization': token }
  // return (
  //   axios.get(process.env.REACT_APP_BASE_URL + 'a23user/get_profilev2?appType=react', { headers: header })
  //   // axios.get(process.env.REACT_APP_NEW_BASE_URL + 'profile/get_profilev2?appType=react', { headers: header })
  // );
  return ({
    data: {
      "avatar": "https://images.fanfight.com/avatars/avatar1.png",
      "screenName": "ghostrider11",
      "username": "CV6dz0sJ",
      "displayName": "ghostrider11",
      "status": true,
      "totalMatchCount": 0,
      "setPassword": true,
      "code": "NX5WPM",
      "totalSeriesCount": 1,
      "mobile": "+918234252342",
      "mobileVerified": true,
      "isEmailEdited": false,
      "_id": "y43h460g26a185j",
      "kyc1": false,
      "kyc2": false,
      "kyc3": false,
      "kyc4": false,
      "kycStatus": "",
      "panStatus": "",
      "emailVerified": false,
      "totalContextCount": 1,
      "level": 5,
      "totalTeamCount": 0,
      "bankStatus": "",
      "bankApproved": false,
      "bankName": "",
      "accountName": "",
      "kycMessage": "",
      "accountNumber": "",
      "panApproved": false,
      "panImage": "",
      "panName": "",
      "panNumber": "",
      "gender": "",
      "dob": "",
      "kycDob": "",
      "totalDepositsCount": 4,
      "playerStatus": "",
      "subscriptionType": "premium",
      "currentTotalAcePoints": 151,
      "currentAceLevel": 1,
      "currentAceLevelName": "bronze",
      "profilePicStatus": "",
      "unverifiedPic": "",
      "bankList": [],
      "googleLinked": false,
      "facebookLinked": false,
      "appleLinked": false,
      "state": "Karnataka",
      "selfExclusion": [],
      "timeOut": [],
      "block": [],
      "aceLevelHintMessage": "Congrats, you are at top ace level.",
      "funBalance": 200000,
      "sysDate": 1771911885423,
      "tnx": 0,
      "bon": 2.15,
      "gems": 3600,
      "blue": 0,
      "totalDeposits": 13100,
      "total": 8811.42,
      "extraCash": 6004.32,
      "win": 2804.95,
      "win_pending": 0,
      "totalWin": 0,
      "totalWinnings": 0,
      "pending_bonus": 0,
      "lastDepositedAmount": 0,
      "lockedTourneyWinnings": 0,
      "showLoginGV": false,
      "loginGvCode": "",
      "selfieApproved": false,
      "selfieStatus": "",
      "bonusToBeExpired": {
        "amount": 0,
        "expiryAt": null
      },
      "showTaxableRunningNetWin": true,
      "showNegativeTaxRunningNetWinnings": true,
      "netWinnings": -5261.78,
      "tdsPaidNetWinning": 0,
      "totalTaxPaid": 0,
      "taxedNetWinning": 0,
      "totalPendingRedeems": 0,
      "whatsappFlag": true,
      "enablebonusReleasedLastXDays": false,
      "bonusReleasedLastXDaysAmt": 0,
      "bonusReleasedLastXDays": 0,
      "redeemableAmount": 2804.95,
      "bonusReleasedLastXDaysList": [],
      "maxBonusAmountPerReferee": 2600,
      "currentFinYear": "April 1, 2025 - March 31, 2026",
      "fyYearString": "FY 25-26",
      "openingBalanceFinYear": 0,
      "panEmailMandatoryConfig": false,
      "getKycWaitTime": 5000,
      "isVip": false,
      "bonusExpiryString": "Bonus expires after 30 days of inactivity from the date of claim",
      "tdsRefundUrl": "",
      "showTaxableNetWin": true,
      "tdsRefundFinYear": "April 1, 2024 - March 31, 2025",
      "contactUsEmailMandatory": true,
      "emailVerifyText": "Hello User, please verify your email to facilitate prompt customer support.",
      "showAadhaarUploadSection": false,
      "redeemWorkflowId": "hdw-user-onboarding-ocr-flow",
      "kycDocMessage": "",
      "panMessage": "",
      "kycDocNumber": "",
      "kycDocType": "",
      "kycUserName": "",
      "kycDocStatus": "",
      "docInProcessing": "",
      "enterAadhaarlimit": false,
      "aadhaarLiteEnabled": true,
      "aadhaarDigilockerEnabled": true,
      "aadhaarManualUploadEnabled": true,
      "userConsentApps": false,
      "newAadhaarWorkflowId": "hdw-user-onboarding-v3",
      "isHVAadhaarDisabled": "yes",
      "isHVPanDisabled": "yes",
      "isHVVoterIdDisabled": "no",
      "isHVDLDisabled": "no",
      "tdsRefundConfig": 5,
      "tdsRefundAmount": 0,
      "tdsRefundEligibility": "No",
      "tdshistoryReportHyperlinkName": "TDS History Report",
      "itrReportHyperlinkName": "ITR Report",
      "fullKycName": "",
      "registeredAt": 1670565289118,
      "userVernacularLanguage": "en",
      "augmont_whitelabel": false,
      "jar_whitelabel": true,
      "incred_whitelabel": true,
      "targetLAMF_SC": true,
      "upswing_whitelabel": true,
      "augmontConsent": false,
      "firstName": "",
      "lastName": "",
      "userConsentFlag": false,
      "taxableRunningNetWin": 1071.3,
      "hypervergeEnable": true,
      "hypervergeAadhaarEnable": true,
      "hypervergePanEnable": true,
      "panworkflowId": "hdw-user-onboarding-panPlus",
      "aadharworkflowId": "hdw-user-onboarding-aadhaar-panPlus-v2",
      "pushToKYC": false
    }
  });

}

export const getQuizCategoriesData = async (token) => {
  return (
    axios.get(process.env.REACT_APP_BASE_URL + 'a23quiz/get_quiz_categories/', { headers: { 'Authorization': token } })
  );
}

export const getNewBonus = async (token, channel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_TS_URL + 'depositBonusCodes' ,
      headers: {
        'Authorization': token
      },
      data: {
          "channel": channel
      },
    })
  )
}

export const getNewBanners = async (token) => {
  return (
    axios({
      method: "GET",
      url: process.env.REACT_APP_PLATFORM_API + "support/offers/promotions" ,
      headers: {
        'Authorization': "Bearer " + token
      }
    })
  )
}

//POST REQUEST FOR SUBMIT BANK DETAILS
export const getLinkBankAccont = (token, accountNum, acountName, ifscCode) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "a23kyc/submitbankdetailsforvalidation/",
      headers: {
        'Authorization': token
      },
      data: {
        // token: token,
        account_number: accountNum,
        account_name: "Not Available",
        ifsc: ifscCode
      },
    })
  );
}

//POST REQUEST FOR VERIFY IFSC CODE DETAILS
export const verifyIFSCCode = (token, ifscVal) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "a23kyc/verify_ifsc/",
      headers: {
        'Authorization': token
      },
      data: {
        // token: token,
        ifscVal: ifscVal
      },
    })
  )
}

//viewCampaignDetails
export const viewCampaignDetails=(token,userId)=>{
  return (
    axios({
      method: "GET",
      url: process.env.REACT_APP_BASE_GP_URL + "campaign/viewCampaignDetails/",
      headers: {
        'Authorization': token
      },
      data: {
        userId: userId
      },
    })
  )

}

//Optin Api in cashback gamepoints
export const optIncashbackgamepoints = (token, userId, campaignId, aceLevel, channelName, userName) => {
  // console.log("with Draw Request Data:::" + token + "amount" + w_type, w_value, w_name)
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_GP_URL + "campaign/optIn/",
      headers: {
        'Authorization': token
      },
      data: {
        userId: userId,
        campaignId: campaignId,
        aceLevel: aceLevel,
        channelName: channelName,
        userName: userName
      },
    })
  )
}


//Getting redeem Details
export const getRedeemDetails = (token) => {
  return (
    axios.get(process.env.REACT_APP_NEW_BASE_URL + 'redeem/redeem_details/', { headers: { 'Authorization': token } })
  );
}


export const getWithdrawRequest = (token, amount, w_type, w_channel, w_value, w_name) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/withdrawal_request/",
      headers: {
        'Authorization': token
      },
      data: {
        amount: amount,
        withdrawType: w_type, // Send one of these param (BANK/WALLET/UPI)
        channel: w_channel,
        bankAccountNumber: w_value,
        name: w_name
      },
    })
  )
}

export const verifyMobile = (token, otp, otpTemplate) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/verify_user/",
      headers: {
        'Authorization': token
      },
      data: otpTemplate !== undefined && otpTemplate !== null ? {
        otp: otp,
        otpTemplate: otpTemplate

      } :
      {
        otp: otp,

      } 
      ,
    })
  )
}

//API For Cancel Withdraw Reqest
export const cancleWithdrawRequest = (w_token, w_tnxId, w_channel,w_location) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/cancel_withdrawal_request/",
      headers: {
        'Authorization': w_token
      },
      data: {
        tnxId: w_tnxId,
        channel: w_channel,
        cancellation_location:w_location
      },
    })
  )
}

//To get Transcation Summery data
export const getTranscationSummeryDetails = (ts_token, ts_numberofdays, ts_transactionType, ts_userid, ts_appType) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_TS_URL + "transactionHistoryV2/",
      headers: {
        'Authorization': ts_token
      },
      data: {
        numberOfDays: ts_numberofdays,
        transactionType: ts_transactionType,
        // id: ts_userid,//For new requirement//Vanurbilities
        // appType: ts_appType
      },
    })
  )
}

//To get Delete Wallet data
export const deleteWallet = (w_token, w_type, w_channel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/remove_wallet/",
      headers: {
        'Authorization': w_token
      },
      data: {
        walletType: w_type,
        channel: w_channel
      },
    })
  )
}

export const getWalletTypeData = (token, wallettype, channel, otp) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/add_wallet/",
      headers: {
        'Authorization': token
      },
      data: {
        walletType: wallettype,
        channel: channel,
        otp: otp
      },
    })
  )
}

export const getRedeemAcePointsData = (token)=>{
  console.log("Debug log get redeem ace points data");
  // return(
  //   axios({
  //     method:"GET",
  //     url:process.env.REACT_APP_BASE_ACE_POINT_URL+"acePoint/userData",
  //     headers:{
  //       'Authorization':token
  //     }
  //   })
  // )
  return ({
    data: {
      "userId": "y43h460g26a185j",
      "userName": "ghostrider11",
      "subscriptionType": "premium",
      "currentAceLevel": 1,
      "lastAceLevel": 0,
      "currentAceLevelName": "bronze",
      "lastLevelAction": "Ace level 1 qualification reset during validity period",
      "nextAceLevelName": "regular",
      "acePointsEarnedInCurrentLevel": 0,
      "currentTotalAcePoints": 151,
      "acePointsRedeemedInCurrentLevel": 0,
      "cashDepositedInCurrentLevel": 0,
      "cashDepositedFromAcePointRedeems": 0,
      "currentLevelValidityStartDate": 1754663290749,
      "currentLevelValidityEndDate": null,
      "lifetimeInCurrentLevel": false,
      "convertAcePts": 10,
      "convertCashValue": 2,
      "redeemLimit": 200,
      "minRedeemableValue": 20,
      "maxRedeemableValue": 200,
      "redeemLimits": {
        "bronze": {
          "min": 20,
          "max": 200
        },
        "regular": {
          "min": 20,
          "max": 200
        },
        "silver": {
          "min": 20,
          "max": 500
        },
        "gold": {
          "min": 20,
          "max": 2000
        },
        "diamond": {
          "min": 20,
          "max": 14999
        },
        "ambassador": {
          "min": 20,
          "max": 1000
        }
      },
      "valueBack": 20,
      "renewAcePointValue": 0,
      "renewDepositValue": null,
      "upgradeAcePointValue": 0,
      "upgradeDepositValue": 0,
      "acePointToCashValue": 30.2,
      "acePointValue": 20,
      "multiplierValue": 100,
      "levelChangeVisibility": "NA",
      "percentageAcePoints": 0,
      "renewPercentage": null,
      "validityDays": null,
      "instantRedeemsLeft": 30,
      "standardRedeemsLeft": 20,
      "currentMonth": "Feb",
      "maxAmountPerRequest": 100000,
      "bonusCode": null,
      "claimsLeft": null,
      "bonusPercentage": null,
      "bonusExpiryAt": null,
      "uptoBonusAmount": null,
      "bonusClaimedNumber": null,
      "voucherCode": null,
      "voucherAmount": null,
      "voucherExpiryAt": null,
      "voucherStatus": "NA",
      "flags": {
        "apRedeemFlag": true,
        "bonusFlag": false,
        "gvFlag": false,
        "packageFlag": true,
        "redeemFlag": true,
        "tourneyFlag": true,
        "priorityFlag": true,
        "bdayGvFlag": true
      },
      "priorityNum": "18002581234",
      "upgradeText": null,
      "renewText": null,
      "acePointToCashText": "Play Games worth ₹100 to earn 20 Ace Points. Upgrade your level to earn higher Ace points.",
      "bdayVoucherAmount": null,
      "bdayVoucherStatus": null,
      "bdayVoucherCode": null,
      "validityAcePoints": 0
    }
  });
}

export const claimRedeemAcePoints = (token,requestObject) => {
  return(
    axios({
      method:"POST",
      url:process.env.REACT_APP_BASE_ACE_POINT_URL + "acePoint/redeem/",
      headers:{
        'Authorization':token
      },
      data:requestObject
    })
  )
}

//Redeem History API
export const getRedeemHistory = (token) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/redeem_history/",
      headers: {
        'Authorization': token
      }
    })
  )
}

export const getUPIData = (upi, confirmupi, otp, token, value, channel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/add_upi/",
      headers: {
        'Authorization': window.sessionStorage["token"]
      },
      data: {
        upi: upi,
        confirmUpi: confirmupi,
        otp: otp,
        token: token,
        submit: value,
        channel: channel
      },
    })
  )
}

//Remove UPI API
export const getRemoveUPIData = (token, upiId, channel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/remove_upi/",
      headers: {
        'Authorization': token
      },
      data: {
        upiId: upiId,
        channel: channel
      }
    })
  )
}


//getFailed transcations data
export const getFailedTranscationsData = (token, ts_userid) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_TS_URL + "failedTransactionList/",
      headers: {
        'authToken': token,
      },

      data: {
        id: ts_userid
      },
    })
  )
}


//Recheck failed transaction API
export const getRecheckTranscationsData = (token, oreder_id) => { 
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL+"platform_pg/transaction_status_check/",
      headers: {
        'Authorization': token
      },
      data: {
        orderId: oreder_id
      },
    })
  )

}

//Remove bankaccount APi
//Recheck failed transaction API
export const getDelinkBankAccount = (token, account_number) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/bank_delink",
      headers: {
        'Authorization': token
      },
      data: {
        account_number: account_number
      },
    })
  )
}

//Get BonusSummery data
export const getBonusSummeryData = (token, bs_userid) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_TS_URL + "bonusSummary/",
      headers: {
        'authToken': token
        // 'Authorization': token
      },
      data: {
        // id: bs_userid//To check vanurbilities //New changes
      },
    })
  )
}

//Get Bonus Summery Data without userid
export const getUserIDFromTokenOnly = (token) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_TS_URL + "userDetails/",
      headers: {
        'Authorization': token
      }
    })
  )
}

//Transaction Recheck API Call for TPSL  
export const getTPSLRecheckTranscationsData = (token, oreder_id, pgChannel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL + "a23pg-tpsl/transaction_status_check/",
      headers: {
        'Authorization': token
      },
      data: {
        orderId: oreder_id
      },
    })
  )
}

//Transaction recheck Api call for Razorpay 
export const getRazorpayRecheckTranscationsData = (token, oreder_id, pgChannel) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL+"platform_pg/transaction_status_check",
      headers: {
        'Authorization': token
      },
      data: {
        orderId: oreder_id
      },
    })
  )
}

export const getUserAmountTDSInfo = (token, gameId, pk_depositAmount, pk_mode, timeStamp, pk_amount, pk_winAmount, playerName, pk_extraCashAmount, pk_promoAmount, pk_sessionToken, currencyCode) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL + "a23poker/tdsInfo",
      headers: {
        'Authorization': token
      },
      data: {
        gameId: gameId,
        depositAmount: pk_depositAmount,
        mode: pk_mode,
        timeStamp: timeStamp,
        amount: pk_amount,
        winAmount: pk_winAmount,
        playerName: playerName,
        extraCashAmount: pk_extraCashAmount,
        promoAmount: pk_promoAmount,
        sessionToken: pk_sessionToken,
        currencyCode: currencyCode
      },
    })
  )
}

//Convert Poker to A23 Balance
export const PokerAmountToA23Transfer = (token, pk_ConversionType) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL + "a23poker/walletConversion",
      headers: {
        'Authorization': token
      },
      data: {
        conversionType: pk_ConversionType
      },
    })
  )
}

//Convert A23 To Poker Transfer
export const A23ToPokerAmountTransfer = (token, pk_ConversionType, pk_amount) => {
  return (
    axios({
      method: "POST",
      url: process.env.REACT_APP_BASE_URL + "a23poker/walletConversion",
      headers: {
        'Authorization': token
      },
      data: {
        conversionType: pk_ConversionType,
        amount: pk_amount
      },
    })
  )
}

